import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next"

import icons from "../../../Data/icons";
  

const CompanySettings = () => {  
  const {t} =useTranslation() 
   const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"))  ||{}
  const Settings = icons.settings;
  const companyId = user.company_id
  

  return (
    <li  className="cursor" onClick={() => navigate(`${process.env.PUBLIC_URL}/companyinformation/${companyId}`)}>
    <Settings />
    </li>
  );
};

export default CompanySettings;
